import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import '@babel/polyfill';

import 'babel-polyfill'

import Es6Promise from 'es6-promise'
Es6Promise.polyfill()


Vue.config.productionTip = false

import as from 'axios'
// import AFRAME from 'aframe';
// // const app=createApp(App);
// Vue.use(AFRAME);
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$axios = as

as.defaults.baseURL = '/POST_DATA'



new Vue({
  render: h => h(App),
  router
}).$mount('#app')
